// import React, { createContext, useContext, useState } from 'react';

// interface User {
//     name: string;
//     profile: string;
// }

// interface UserContextProps {
//     user: User | null;
//     setUser: (user: User | null) => void;
// }

// const UserContext = createContext<UserContextProps | undefined>(undefined);

// export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//     const [user, setUser] = useState<User | null>(null);

//     return (
//         <UserContext.Provider value={{ user, setUser }}>
//             {children}
//         </UserContext.Provider>
//     );
// };

// export const useUser = (): UserContextProps => {
//     const context = useContext(UserContext);
//     if (!context) {
//         throw new Error('useUser must be used within a UserProvider');
//     }
//     return context;
// };


import React, { createContext, useContext, useState, useEffect } from 'react';
import { getStoredUser, hasValidSession, setStoredUser } from './session';

interface User {
    user_id: number;
    name: string;
    profile: string;
    avatar?: string;
    company_id?: number; // Adicionando company_id como opcional
}

interface UserContextProps {
    user: User | null;
    setUser: (user: User | null) => void;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<User | null>(() => {
        // Só aproveita o usuário guardado se o token ainda estiver válido;
        // caso contrário a tela logada apareceria com credencial vencida.
        return hasValidSession() ? (getStoredUser() as User | null) : null;
    });

    // Mantém a sessão em dia sempre que o estado do usuário mudar.
    useEffect(() => {
        if (user) {
            setStoredUser(user);
        } else {
            sessionStorage.removeItem('user');
        }
    }, [user]);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = (): UserContextProps => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
